import PropTypes from 'prop-types';

import bucketShape from './bucket';
import feesShape from './fees';
import legsShape from './legs';
import productsShape from './products';

export default PropTypes.shape({
  bookingItems: productsShape,
  buckets: PropTypes.arrayOf(bucketShape),
  canBeBooked: PropTypes.bool,
  class: PropTypes.shape({
    code: PropTypes.string
  }),
  fees: feesShape,
  flexibilityLevel: PropTypes.number,
  legs: legsShape,
  offlineFee: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string,
    passengerId: PropTypes.string,
    price: PropTypes.number,
    tariffCode: PropTypes.string
  }),
  prices: PropTypes.shape({
    displayPrice: PropTypes.number
  }),
  promo: PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.number
  }),
  productFamily: PropTypes.shape({
    code: PropTypes.string,
    name: PropTypes.string
  })
});
